<template>
  <div class="container offset-md-3 col-md-6 pt-5 pb-5">
    
    <h2>パスワードリセット</h2>
    
    <toast ref="toast"></toast>

    <form @submit.prevent="resetPassword">
      <div class="form-group">
        <label for="mail">登録されたメールアドレス宛に新しいパスワードが送信されます</label>
        
        <p v-if="invalid" class="text-danger">無効なメールアドレスです</p>
        <input type="mail" class="form-control" :class="{'border-danger' : invalid}" id="mail" placeholder="メールアドレス" v-model="mail" required>
      </div>
      <input type="button" class="btn btn-secondary" value="戻る" @click="$router.go(-1)"/>
      <input type="submit" class="btn btn-primary" value="リセット"/>
    </form>
  </div>
</template>

<style scoped>
</style>

<script>
import CommonAPI from '../../api/common-api'
import UserAPI from '../../api/user-api'
import Toast from '../Toast.vue'

export default {
  name: "reset-password",
  components: {
    Toast
  },
  data() {
    return {
        invalid: false,
        mail: ''
    }
  },
  mounted () {
    this.$root.$refs.loading.$data.show = false
  },
  methods: {
    /**
     * パスワードリセット
     */
    resetPassword () {
      // メールアドレスが妥当かチェック
      if(!this.checkEmailAddress(this.mail)){
        this.invalid = true
        return false
      }

      this.$root.$refs.loading.$data.show = true
      // 存在するユーザか
      const body = {
        mail: this.mail
      }
      UserAPI.isExists(body)
        .then(res => {
          this.invalid = !res.isExists;
          if (this.invalid) {
            this.$root.$refs.loading.$data.show = false
            this.$refs.toast.showToast("無効なメールアドレスです", 3000, true)
            return false
          } else {
          CommonAPI.resetPassword(this.mail)
                .then(res => {
                  alert("メールを送信しました")
                  this.$router.push('/login')
                  this.$root.$refs.loading.$data.show = false
                })
                .catch(err => {
                  console.error(err)
                  this.$root.$refs.loading.$data.show = false
                })
          }
        })
        .catch(err => {
          console.error(err)
        })
    },
    checkEmailAddress (mail) {
        return mail.match(/.+@.+\..+/) != null
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/assets/js/components/common/ResetPassword.vue